import React from 'react';
import { connect } from 'react-redux';
import { shareAnswerKey } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  shareAnswerKey,
};

function ModalShareAnswerKey({ data, shareAnswerKey, closeModal }) {
  const { auth, history, item } = data;

  function onShare() {
    shareAnswerKey(auth, history, item.id);
    closeModal();
  }
  return (
    <Modal variant='info' closeModal={closeModal}>
      <p className='my-3 mx-1'>
        Apakah Anda yakin ingin membagikan kunci jawaban{' '}
        <span className='has-text-info has-text-weight-semibold'>{`${item.title}`}</span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={onShare} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalShareAnswerKey);
